


<table mat-table [dataSource]="hotelData" multiTemplateDataRows style="background-color: transparent;">
                       
  <!-- <ng-container matColumnDef="expand">
    <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
    <td mat-cell *matCellDef="let element">
    <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
      <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
      <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
    </button>
    </td>
    </ng-container> -->
   <ng-container matColumnDef="data1">
     <th mat-header-cell *matHeaderCellDef>Plan Code</th>
     <td mat-cell *matCellDef="let element" > {{element?.planCode}} </td>
   </ng-container>

  <ng-container matColumnDef="data2">
   <th mat-header-cell *matHeaderCellDef>  Priority </th>
   <td mat-cell *matCellDef="let element" >  {{element?.planPriority}}
  </td>
  </ng-container>
  <ng-container matColumnDef="data3">
    <th mat-header-cell *matHeaderCellDef> isDefaultPlan  </th>
    <td mat-cell *matCellDef="let element"> 
      {{element?.isDefaultPlan}}
      

     </td>
   </ng-container> 
    <ng-container matColumnDef="data4">
    <th mat-header-cell *matHeaderCellDef> Action </th>
    <td mat-cell *matCellDef="let element">    
     <button (click)="onRowClick(element)" mat-raised-button>View</button>
    </td>
   </ng-container>  
   <!-- <ng-container matColumnDef="data5">
    <th mat-header-cell *matHeaderCellDef> Commercial </th>
    <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);"  (click)="rowdataClick(element)"> {{"View"}} </td>
   </ng-container> -->
 
  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <!-- <ng-container matColumnDef="expandedDetail">
  <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDataDisplay.length">
  
  </td>
  </ng-container> -->
  
  <tr mat-header-row *matHeaderRowDef="columnsDataDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsDataDisplay;"
  class="example-element-row">
  </tr>
  <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->
  <tr class="mat-row" *matNoDataRow>
  <td  class="mat-cell" colspan="4">There is no data in this table</td>
  </tr>
  </table>



  <p-dialog [header]="title" [(visible)]="display" [modal]="true" [closable]="true" [style]="{ width: '83rem' }">
<div class="p-fluid " style="height: 70vh;">
<div class="col-md-12 mt-3" >
<div class="container" >
<table class="commercial-table">

<tbody>
<tr>
<td >Plan Code</td>
<td style="width: 12.5%;"> 
<input  type="text" [(ngModel)]="commercialMapping.planCode">
</td>
<td >isDefaultPlan</td>
<td style="width: 12.5%;">
<input type="checkbox" [(ngModel)]="commercialMapping.isDefaultPlan">

</td>
<td >Priority</td>
<td style="width: 12.5%;"> 
<select  name="type" [(ngModel)]="commercialMapping.planPriority">

<option *ngFor="let number of numbers" [value]="number">{{number}}</option>


</select></td>
<td >Add Commercials</td>
<td style="width: 12.5%;">   <button mat-raised-button (click)="addCommercials()">Add</button>
</td>
</tr>  </tbody></table> 

<span class="col-md-12" *ngFor="let item of commercialMapping.commercialPlanItems;let i=index" class="card shadow mt-1">
<div class="row " style="padding: 4px;">
<div class="col-md-6 d-flex justify-content-start" >
<h5 >Commercial .{{i+1}}</h5>
</div>
<div class="col-md-6 mb-2 d-flex justify-content-end">
<button *ngIf="clearCommercial" (click)="clear(i)" color="warn">Clear</button>
</div>
</div>
<table class="commercial-table">

<tbody>
<tr>
<td>Source</td>
<td> <select name="source" [(ngModel)]="item.source" (change)="getSupplierlist(item,$event)">
  
<option value="Default">{{'Default'}}</option>
<option  *ngFor="let list of sourceList" [value]="list.code">{{list?.name}}</option>
<!-- <option  value="expedia">{{'Expedia'}}</option> -->
<!-- <option  value="agoda">{{'Agoda'}}</option> -->


</select></td>
<td>Supplier</td>
<td>
<select name="supplier"  [(ngModel)]="item.supplier">
<option value="Default">{{'Default'}}</option>
<option  *ngFor="let list of item?.supplierList" [value]="list.code">{{list?.name}}</option>
<!-- <option  value="expedia">{{'Expedia'}}</option>
<option  value="agoda">{{'Agoda'}}</option> -->
</select>
</td>
<td>Type</td>
<td> <select  name="type" [(ngModel)]="item.bookingType">

<option  value="D">{{'Domestic'}}</option>
<option  value="I">{{'International'}}</option>


</select></td>
</tr>  </tbody></table>  
    <table class="col-md-12 commercial-table">
      <thead>
        <tr>
          <th>Commercial Category</th>
          <th>Commercial Rate</th>
          <th>Commercial Fixed</th>
          <th>On Base</th>
          <th>On Tax</th>
          <th>Deduct TDS</th>
          <th>Applicability</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let commercialRates of item.commercialRates ">
          <td>{{commercialRates.commercialCategory}}</td>
          <td><input (keypress)="SettingsService.onlyNumberKey($event)" type="text" [(ngModel)]="commercialRates.commercialRatePercent" /></td>
          <td><input (keypress)="SettingsService.onlyNumberKey($event)" type="text" [(ngModel)]="commercialRates.commercialRateFixed"/></td>
          <td><input  type="checkbox" [(ngModel)]="commercialRates.commercialOnBase"/></td>
          <td><input type="checkbox" [(ngModel)]="commercialRates.commercialOnTax"/></td>
          <td><input type="checkbox" [(ngModel)]="commercialRates.deductTds"/></td>
          <td >
            <select *ngIf="commercialRates.commercialCategory==='Booking Fee'" name="commercialApplicability" [(ngModel)]="commercialRates.commercialApplicability">
              <option value="Per Room">Per Room</option>
              <option value="Per Room Night">Per Room Night</option>
            </select>
          </td>
        </tr>
        
  
        <!-- PassBack Supplier Commission Row -->
        <tr>
          <td>PassBack Supplier Commission</td>
          <td >

<input type="checkbox" [(ngModel)]="item.enablePassback" /> Enable PassBack

</td>
<td >
<!-- <label>Retain rate</label>
<input type="number" /> -->
<mat-form-field  appearance="outline">
<mat-label>Retain rate</mat-label>
<input (keypress)="SettingsService.onlyNumberKey($event)" matInput type="text" [(ngModel)]="item.passbackRetainRate"     >
</mat-form-field>
</td>
<td >

<input type="radio"   [(ngModel)]="item.passbackAs"  value="P"/>As Part
<input type="radio"   [(ngModel)]="item.passbackAs" value="T" />On Total
</td>
</tr>

<!-- MarkUp Section Row -->
<!-- ################################################## -->

<tr   *ngFor="let markup of item.markupRates ">
<td  style="font-weight: bold;">MarkUp</td>
<td style="background-color: gainsboro;font-weight: bold;"> 
<label>{{markup?.category}}</label>
</td>
<td>
<mat-form-field  appearance="outline">
<mat-label>Rate</mat-label>
<input matInput (keypress)="SettingsService.onlyNumberKey($event)" [(ngModel)]="markup.markupPercent" type="text" >
</mat-form-field> 
</td>
<td> <mat-form-field  appearance="outline">
<mat-label>Fixed</mat-label>
<input matInput (keypress)="SettingsService.onlyNumberKey($event)" [(ngModel)]="markup.markupFixed" type="text" >
</mat-form-field> </td>
<td> <mat-form-field  appearance="outline">
<mat-label>Maximum</mat-label>
<input matInput (keypress)="SettingsService.onlyNumberKey($event)" [(ngModel)]="markup.markupMax" type="text" >
</mat-form-field> </td>
<td></td>
<td></td>


</tr>

</tbody>
</table>
</span>
<!-- Buttons -->

</div>

</div>
</div>
<ng-template pTemplate="footer">

<div *ngIf="action==='update'" class="buttons ">
<button mat-raised-button (click)="updateHoteCommercial()">Update</button>
<!-- <button color="warn">Delete</button> -->
</div>
<div *ngIf="action==='new'" class="buttons">
<button mat-raised-button (click)="CreateCommercial()" [disabled]="disable()" >Save</button>
</div>
</ng-template>
</p-dialog>

